import api from './api';
import {
  normalizeBookingServicePackageEntitlement,
  normalizeCustomerServicePackage,
  toFormServicePackage,
} from './servicePackageService';

const withCustomerStore = (storeId) => ({
  _authContext: 'customer',
  _storeId: storeId,
});

export const getStoreServicePackages = async (storeId) => {
  const response = await api.get('/service-packages/catalog', withCustomerStore(storeId));

  return (response.data || []).map(toFormServicePackage);
};

export const getCustomerServicePackages = async (storeId) => {
  const response = await api.get('/service-packages/customer-packages', withCustomerStore(storeId));

  return (response.data || []).map(normalizeCustomerServicePackage);
};

export const createServicePackageCheckoutSession = async (storeId, packageId) => {
  const response = await api.post(
    `/service-packages/${packageId}/checkout-session`,
    null,
    withCustomerStore(storeId),
  );

  return {
    clientSecret: response.data?.clientSecret ?? response.data?.ClientSecret ?? null,
    // Direct charges live on the store's Stripe account; Stripe.js must be opened on it.
    stripeAccountId: response.data?.stripeAccountId ?? response.data?.StripeAccountId ?? null,
  };
};

export const getBookingServicePackageEntitlements = async (storeId, serviceIds, date) => {
  const response = await api.post(
    '/service-packages/booking-entitlements',
    { serviceIds, date: date || null },
    withCustomerStore(storeId),
  );

  return (response.data || []).map(normalizeBookingServicePackageEntitlement);
};
